import { HttpClient } from '@/shared/infra/http/HttpClient';
import { GeneratedReport } from '../../application/domain/entities/GeneratedReport';

/** An account's saved report files (core-service, super admin only for now). */
export class ApiGeneratedReportRepository {
  constructor(private readonly core: HttpClient) {}

  /** Newest report date first, as the server orders it. */
  async list(accountId: string): Promise<GeneratedReport[]> {
    const res = await this.core.get<GeneratedReport[]>(
      `/generated-reports/accounts/${encodeURIComponent(accountId)}`
    );
    return res.data ?? [];
  }

  /** The CSV itself. The route answers raw bytes, not the usual `{ data }` envelope. */
  async download(accountId: string, generatedReportId: string): Promise<Blob> {
    const res = await this.core.get(
      `/generated-reports/accounts/${encodeURIComponent(accountId)}/${encodeURIComponent(generatedReportId)}/download`,
      { responseType: 'blob' }
    );
    return res as unknown as Blob;
  }
}
